export default __webpack_public_path__ + "static/media/5.4b3ee6dc.png";